import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AnonymousAccountTrackingLocation } from '../types';
import META from './useTrackViewedAnonymousAccountCreationForm.meta';

export type TrackViewedAnonymousAccountCreationFormParams = {
  share_url: string;
  object_id: string;
  object_type: 'clip' | 'board' | 'collection' | 'canvas';
  location: AnonymousAccountTrackingLocation;
};

export const useTrackViewedAnonymousAccountCreationForm = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedAnonymousAccountCreationForm = useCallback(
    (params: TrackViewedAnonymousAccountCreationFormParams) => {
      track(META.name, params);
    },
    [track],
  );

  return {
    trackViewedAnonymousAccountCreationForm,
  };
};
